import React, { Component } from 'react'
import { Box, CustomizedErrorMessage } from '../../styles.style'
import { getIn } from 'formik'
import { ClientService } from '../../../../services/client.service'
import { validate } from '../../../../services/cpf.service'
import {
	CPFInput
} from '../../../../components/form-components/inputs.component'

class DocumentCPF extends Component {
	constructor(props) {
		super(props)
		this.state = {
			cpf: ''
		}
	}

	nextPage = () => {
		this.props.handleSetCpf(this.props.values.cpf)
		this.props.nextStep()
	}

	handleCompleteCpfField = () => {
		
		const { providerSignupData, showLoading, hideLoading } = this.props
		showLoading()

		let cpf = this.props.values.cpf;
		let errorMessage = ''

		if (!cpf) {
			errorMessage = 'Informe o CPF'
		}
		if (cpf.length < 11) {
			errorMessage = 'Informe os 11 caracteres'
		}
		if (!validate(cpf))
			errorMessage = 'CPF inválido'

		this.setState({ cpf: cpf, cpfError: errorMessage })
		if (errorMessage) {
			hideLoading()
			return;
		}

		var obj = { cpf, email: providerSignupData.email }
		ClientService.checkExistingPDFDocument(obj).then(data => {
			if (data.success) {
				if (data.data) {
					this.setState({ cpf: cpf, cpfError: 'Já existe um usuário cadastrado com os dados informados' })
				}
			}
			hideLoading()
		})

		this.setState({ cpf: cpf, cpfError: errorMessage })
	}


	render() {
		const {
			values,
			errors,
			touched
		} = this.props
		const { cpfError } = this.state
		return (
			<Box>
				<div className="field">
					<header>
						<h5>Nos informe seu CPF</h5>
					</header>
					<CPFInput
						{...this.props}
						id="cpf"
						placeholder="CPF - Somente números"
						onComplete={this.handleCompleteCpfField}
					/>
					{cpfError && (
						<CustomizedErrorMessage>
							{cpfError}
						</CustomizedErrorMessage>
					)}
				</div>
				<button
					disabled={
						!values.cpf ||
						this.state.cpfError ||
						values.cpf.length < 11 ||
						(errors.cpf && touched.cpf)
					}
					className={
						errors.cpf && touched.cpf || this.state.cpfError
							? 'disabled button'
							: 'button'
					}
					type="button"
					onClick={() => this.nextPage()}>
					Próximo
					</button>
			</Box>
		)
	}
}

export default DocumentCPF
